import { MatIconModule } from '@angular/material/icon';
import { MatInputModule as MatInputModule} from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { ColorPickerComponent } from './color-picker.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';
import { ColorChromeModule} from 'ngx-color/chrome';


@NgModule({
  declarations: [ColorPickerComponent],
  imports: [
    CommonModule,
    OverlayModule,
    ColorChromeModule,
    FormsModule,
    MatInputModule,
    MatIconModule
  ],
  exports: [ColorPickerComponent]
})
export class ColorPickerModule { }
